import axios from 'axios'
import router from '@/router'
import { getToken } from '@/require/auth.js'
const http = axios.create({
        // baseURL: 'http://10.0.0.211:2019',
        // baseURL: 'http://10.0.0.210:2019/ydylapi',
        // baseURL: 'http://testydyl.drcnet.com.cn/ydylapi',
        // baseURL: '/ydylapi',
        baseURL: 'https://ydyl.drcnet.com.cn/ydylapi', // 本地测试使用，将host文件更改为10.0.0.58 ydyl.drcnet.com.cn 映射ip
        // 请求 30s 超时
        timeout: 300000,
        headers: {
            post: {
                'Content-Type': 'application/json;charset=utf-8'
                    // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
            },
            get: {
                // 'Content-Type': 'application/json;charset=utf-8'
                // 在开发中，一般还需要单点登录或者其他功能的通用请求头，可以一并配置进来
            }
        }
    })
    // 请求拦截器
http.interceptors.request.use((config) => {
    // console.log('进入请求拦截')
    if (getToken()) {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        config.headers.Authorization = getToken()
    }
    return config
}, (error) => {
    // 错误抛到业务代码
    error.data = {}
    error.data.msg = '服务器异常，请联系管理员！'
    return Promise.resolve(error)
})

// 响应拦截器
http.interceptors.response.use((response) => {
    // console.log(response.data, '拦截')
    if (response.data.code === 301) {
        return router.replace('/power')
    } else {
        return response
    }
}, (error) => {
    // 错误抛到业务代码
    error.data = {}
    error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员！'
    return Promise.resolve(error)
})

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
    router.replace({
        path: '/',
        query: {
            redirect: router.currentRoute.fullPath
        }
    })
}

// 根据不@同的状态码，生成不同的提示信息
const showStatus = (status) => {
    let message = ''
        // 这一坨代码可以使用策略模式进行优化
    switch (status) {
        case 400:
            message = '请求错误(400)'
            break
        case 401:
            message = '未授权，请重新登录(401)'
            break
        case 403:
            message = '拒绝访问(403)'
            break
        case 404:
            message = '请求出错(404)'
            break
        case 408:
            message = '请求超时(408)'
            break
        case 500:
            message = '服务器错误(500)'
            break
        case 501:
            message = '服务未实现(501)'
            break
        case 502:
            message = '网络错误(502)'
            break
        case 503:
            message = '服务不可用(503)'
            break
        case 504:
            message = '网络超时(504)'
            break
        case 505:
            message = 'HTTP版本不受支持(505)'
            break
        default:
            message = `连接出错(${status})!`
    }
    return `${message}，请检查网络或联系管理员！`
}

export default http